import React from 'react';
import { lazy } from 'react';

// project import
import Loadable from '../view-components/Loadable';
import MainLayout from '../views/layout/MainLayout';
import { RequireAuth } from '../view-components/RequireAuth';
import Support from '../views/contact/support';
import NotFound404 from '../views/NotFound404';
const AddPaymentMethod = Loadable(lazy(() => import('../views/billing/AddPaymentMethod')));
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard')));
const Users = Loadable(lazy(() => import('../views/users/Users')));
const Plans = Loadable(lazy(() => import('../views/plans/Plans')));
const PlanPayments = Loadable(lazy(() => import('../views/billing/PlanPayments')));
const PlanDetails = Loadable(lazy(() => import('../views/plans/PlanDetails')));
const PlanCancel = Loadable(lazy(() => import('../views/plans/PlanCancel')));
const PlanReactivate = Loadable(lazy(() => import('../views/plans/PlanReactivate')));
const PlanUpdate = Loadable(lazy(() => import('../views/plans/PlanUpdate')));
const ContactUs = Loadable(lazy(() => import('../views/contact/contactUs')));
const Billing = Loadable(lazy(() => import('../views/billing/Billing')));
const UserCreate = Loadable(lazy(() => import('../views/users/UserCreate')));
const UserUpdate = Loadable(lazy(() => import('../views/users/UserUpdate')));
const Account = Loadable(lazy(() => import('../views/account/Account')));
const ProcessInstructions = Loadable(lazy(() => import('../views/stations/ProcessInstructions')));
const BuildRouteTemplate = Loadable(lazy(() => import('../views/stations/BuildRouteTemplate')));
const ViewRoute = Loadable(lazy(() => import('../views/stations/ViewRoute')));
const ListRoutes = Loadable(lazy(() => import('../views/stations/ListRoutes')));
const ListRouteTemplates = Loadable(lazy(() => import('../views/stations/ListRouteTemplates')));
const ListStations = Loadable(lazy(() => import('../views/stations/ListStations')));
const ViewStation = Loadable(lazy(() => import('../views/stations/ViewStation')));
const ModifyRouteTemplate = Loadable(lazy(() => import('../views/stations/ModifyRouteTemplate')));
const ModifyRoute = Loadable(lazy(() => import('../views/stations/ModifyRoute')));
const ViewStop = Loadable(lazy(() => import('../views/stations/ViewStop')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <RequireAuth>
            <MainLayout />
        </RequireAuth>
    ),
    children: [
        {
            path: 'dashboard',
            children: [
                {
                    path: 'default',
                    element: <ListRoutes />
                }
            ]
        },
        {
            path: '/',
            children: [
                {
                    path: '/stations/build-route/',
                    element: <ProcessInstructions />
                },
                {
                    path: '/stations/build-route-template/',
                    element: <BuildRouteTemplate />
                },
                {
                    path: '/stations/routes',
                    element: <ListRoutes />
                },
                {
                    path: '/stations/route/:id',
                    element: <ViewRoute />
                },
                {
                    path: '/stations/route/:routeId/stop/:stopId',
                    element: <ViewStop />
                },
                {
                    path: '/stations/route/:id/edit',
                    element: <ModifyRoute />
                },
                {
                    path: '/stations/route-templates',
                    element: <ListRouteTemplates />
                },
                {
                    path: '/stations/route-templates/:id/edit',
                    element: <ModifyRouteTemplate />
                },
                {
                    path: '/stations/stations',
                    element: <ListStations />
                },
                {
                    path: '/stations/station/:id',
                    element: <ViewStation />
                },
                {
                    path: '/support/',
                    element: <Support />
                },
                {
                    path: '/account/',
                    element: <Account />
                },
                {
                    path: '/billing/',
                    element: <Billing />
                },
                {
                    path: '/billing_add_payment_method',
                    element: <AddPaymentMethod />
                },
                {
                    path: '/billing/payment_method_update/:paymentMethodId',
                    element: <Billing />
                },
                {
                    path: '/plans/',
                    element: <Plans />
                },
                {
                    path: '/plans/:id',
                    element: <PlanDetails />
                },
                {
                    path: '/plan_update/:id',
                    element: <PlanUpdate />
                },
                {
                    path: '/plan_cancel',
                    element: <PlanCancel />
                },
                {
                    path: '/plan_reactivate',
                    element: <PlanReactivate />
                },
                {
                    path: '/plans/contact_us',
                    element: <ContactUs title="Enterprise Pricing Options Request" />
                },
                {
                    path: '/plans/payments',
                    element: <PlanPayments />
                },
                {
                    path: '/users/',
                    element: <Users />
                },
                {
                    path: '/user_create',
                    element: <UserCreate />
                },
                {
                    path: '/user_update/:id',
                    element: <UserUpdate />
                }
            ]
        },
        {
            path: '*',
            element: <NotFound404 />
        }
    ]
};

export default MainRoutes;
